import { create } from 'zustand'
import { produce } from 'immer'

export const useSupport = create((set) => ({
  data: {
    tickets: [],
  },
  actions: {
    setTickets: (tickets) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.tickets = tickets
        }),
      ),
  },
}))
